import { Injectable } from '@angular/core';
import { loadUserData } from '../utils/crypto.utils';

@Injectable({
  providedIn: 'root',
})
export class ReturnUrlService {
  private readonly DASHBOARD_URL = '/dashboard';
  private readonly ACTIVITY_DASHBOARD_URL = '/activity-dashboard';
  private readonly STORAGE_KEY = 'returnUrl';

  private getDashboardUrl(): string {
    const userData = loadUserData();
    return userData?.isSuperAdmin
      ? this.ACTIVITY_DASHBOARD_URL
      : this.DASHBOARD_URL;
  }

  setReturnUrl(url: string | null): void {
    const userData = loadUserData();
    if (userData && url && this.isValidReturnUrl(url)) {
      localStorage.setItem(this.STORAGE_KEY, decodeURIComponent(url));
    }
  }

  getReturnUrl(): string {
    return localStorage.getItem(this.STORAGE_KEY) || this.getDashboardUrl();
  }

  clearReturnUrl(): void {
    localStorage.removeItem(this.STORAGE_KEY);
  }

  private isValidReturnUrl(url: string): boolean {
    return url !== '/login' && url !== '/verify-user' && url.startsWith('/');
  }
}
